import React from "react";
import { AppHeader, AppNavigator } from "./components";
import { AppContext } from "./context";
import { fetchInitialData, getAppcuesUserIdentity } from "./remote";

import "./App.less";
import "./remote";
// import { AppNotification } from "./components/AppNotification";
import { AppAnnouncementModal } from "./components/AppAnnouncementModal";

const resource = fetchInitialData();

function App({ appcuesEnabled }: { appcuesEnabled: boolean }) {
    const { state, setInit, toggleFullMenu } = React.useContext(AppContext);
    const dataProps = resource.payslip.read();

    React.useEffect(() => {
        if (dataProps.navLinks && dataProps.user) {
            setInit(dataProps);

            const body = document.body || document.getElementsByTagName("body");
            body.classList.add("ss-dashboard-wrapper");
        }

        if (dataProps.user && appcuesEnabled) {
            getAppcuesUserIdentity().then((user: any) => {
                window.Appcues && runAppcuesIdentify(user);
            });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const runAppcuesIdentify = (user: any) => {
        const roles: string[] = user.userRoles || [];
        const role = roles.length > 0 ? roles.shift() : "";
        let otherRoles = {};
        if (user.userRoles.length > 1) {
            const rolesArray = ["role2", "role3", "role4", "role5"];
            otherRoles = Object.fromEntries(new Map(roles.map((role, index) => [rolesArray[index], role])));
        }
        window.Appcues.identify(user.memberId || user.employeeNo, {
            firstName: user.firstName,
            lastName: user.lastName,
            email: user.emailHome || user.emailWork,
            role,
            ...otherRoles,
            companyId: user.companyNo,
            employeeNo: user.employeeNo,
            country: user.country,
            employeeStartDate: user.employeeStartDate,
            isEmployee: user.isEmployee,
            isAdmin: user.isAdmin,
            isManager: user.isManager,
        });

        window.Appcues.group(user.companyNo, { companyId: user.companyNo, companyName: user.companyName });
    };

    return (
        <>
            <AppHeader title="" onMenuClick={() => toggleFullMenu()} />
            <AppNavigator showFullMenu={state.showFullMenu} onCollapseBtnClick={() => toggleFullMenu()} />
            {state.announcements !== null && state.appLink?.Read ? <AppAnnouncementModal /> : null}
        </>
    );
}

export default App;
